import { render, staticRenderFns } from "./Vozvrat_po_tovarov.vue?vue&type=template&id=46872d1d&"
import script from "./Vozvrat_po_tovarov.vue?vue&type=script&lang=js&"
export * from "./Vozvrat_po_tovarov.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports